module.exports = __webpack_public_path__ + "img/treasuries-transactions.2f267c4e.svg";